import React, { useEffect, useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import CopyToClipboard from 'react-copy-to-clipboard'
import "./Banner.css";
import BASE_URL from "../../baseUrl/baseUrl";


const Banner = () => {
  const params = useParams();
  const custome = useRef();
  const currentURL = window.location.href;

  const [data, setData] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(
        `${BASE_URL}/submitlisting/submit/${params.id}`
      )
      .then((res) => {
        setData([res.data.result]);

      })
      .catch((err) => {
        setError(err.message);
      });
  }, [params.id]);

  const next = () => {
    custome.current.slickNext();
  };
  const previous = () => {
    custome.current.slickPrev();
  };

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    speed: 10,
    autoplay: true,
  };
  return (
    <div
      className="banner banner-2 slider-no-padding"
      style={{ padding: "2%" }}
    >
      <div className="banner-item">
        {data?.Gallery && Array.isArray(data.Gallery.picture[0]) && data.Gallery.picture[0].length > 0 ? (
          <Slider
            className="banner-slider"
            ref={custome}
            {...settings}
          >
            {data.Gallery.picture[0].map((item, i) => (
              <div key={i}>
                <div
                  className="banner-inner bg-cover bg-center"
                  style={{
                    backgroundImage: `url(${item})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>

              </div>
            ))}
          </Slider>
        ) : (
          <></>
        )}
        {data.BasicInformation ? (
          <div className="acr-listing-details">
            <div className="acr-listing-section">
              <div className="acr-listing-nav">
                <Link to="#" className="btn-custom secondary">
                  Print Listing
                </Link>
              </div>
              <div className="acr-listing-section-body">
                <div className="acr-listing-section-price">
                  <h5>
                    <span>{data.Details.id}</span>
                  </h5>
                  <span>{data.BasicInformation.status}</span>
                  <h3 style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {data.BasicInformation.currency}
                    {data.BasicInformation.price}
                    {data.BasicInformation.status.split(", ").includes('Rental') ? (
                      <span className="rentalPrice">/{data.BasicInformation.period}</span>
                    ) : (
                      <></>
                    )}{" "}
                  </h3>
                  <p>
                    {" "}
                    <span className="listing-price">
                      { }
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="acr-listing-section">
              <div className="acr-listing-section-body">
                <h4>{data.BasicInformation.type}</h4>
                <div className="acr-listing-icons">
                  <div className="acr-listing-icon">
                    <i className="flaticon-bedroom" />
                    <span>Beds</span>
                    <span className="acr-listing-icon-value">
                      {data.Details.beds}
                    </span>
                  </div>
                  <div className="acr-listing-icon">
                    <i className="flaticon-bathroom" />
                    <span>Baths</span>
                    <span className="acr-listing-icon-value">
                      {data.Details.bathrooms}
                    </span>
                  </div>
                  <div className="acr-listing-icon">
                    <i className="flaticon-ruler" />
                    <span>Sqft</span>
                    <span className="acr-listing-icon-value">
                      {data.BasicInformation.space}
                    </span>
                  </div>
                </div>
                <p>{data.BasicInformation.description}</p>
              </div>
            </div>
            <div className="acr-listing-section">
              <div className="acr-listing-controls">
                <CopyToClipboard text={currentURL}>
                  <Link to="#" className="acr-listing-control">
                    <i className="flaticon-share" />
                  </Link>
                </CopyToClipboard>
                <Link to="#" className="acr-listing-control">
                  <i className="flaticon-star" />
                </Link>
                <Link to="#" className="acr-schedule-tour acr-listing-control">
                  <i className="flaticon-event" />
                  <span>Schedule Link tour</span>
                </Link>
              </div>
              <div className="acr-listing-section-body">
                <div className="acr-listing-meta">
                  <div className="row">
                    <div className="col-lg-6 col-md-3 col-sm-3">
                      <div className="acr-listing-meta-item">
                        <span>Type</span>
                        <p>{data.BasicInformation.type}</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-3 col-sm-3">
                      <div className="acr-listing-meta-item">
                        <span>View</span>
                        <p>{data.Details.view}</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-3 col-sm-3">
                      <div className="acr-listing-meta-item">
                        <span>Lot Size</span>
                        <p>{data.Details.lotsize}</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-3 col-sm-3">
                      <div className="acr-listing-meta-item">
                        <span>Condition</span>
                        <p>{data.Details.condition}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <span>{error}</span>
        )}
      </div>

    </div>
  );
};

export default Banner;
